var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-list-cell',{staticClass:"weight",class:{'is-summary': _vm.summary},attrs:{"type":"stat","format":_vm.format}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }